const LEGACY_PRODUCTION_HOSTS = ['www.lottoland.co.uk', 'lottoland.co.uk'] as const;

const HTTP_PROTOCOLS = ['http:', 'https:'];

const parseUrl = (value: string, base?: string): URL | null => {
  try {
    return new URL(value, base);
  } catch {
    return null;
  }
};

/**
 * Whether the pathname is the route itself or sits below it (exact or `/` boundary).
 * `/betclubs` does not match `/betclub`.
 */
function matchesRoutePath(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`);
}

/**
 * Normalises a link to a relative `pathname + search + hash` when it points to this site or to a legacy site.
 * Legacy hosts are the production legacy hosts plus the host of the current `legacySiteUrl`.
 * Anything else (other hosts, non-http protocols, invalid URLs) returns null and never throws.
 */
function toLegacyRelativePath(href: string, legacySiteUrl: string, currentOrigin: string): string | null {
  const url = parseUrl(href, currentOrigin);
  if (!url || !HTTP_PROTOCOLS.includes(url.protocol)) return null;

  const allowedHosts: string[] = [...LEGACY_PRODUCTION_HOSTS];
  const legacyHost = parseUrl(legacySiteUrl)?.host;
  if (legacyHost) allowedHosts.push(legacyHost);

  const isCurrentSite = url.origin === currentOrigin;
  if (!isCurrentSite && !allowedHosts.includes(url.host)) return null;

  return `${url.pathname}${url.search}${url.hash}`;
}

export { LEGACY_PRODUCTION_HOSTS, matchesRoutePath, toLegacyRelativePath };
